export const TOUR_SEEN_STORAGE_KEY = "bitetrack-tour-v1-seen";
export const TOUR_REPLAY_EVENT = "bitetrack:replay-tour";

export interface TourFlagStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

export function shouldStartTour(storage: TourFlagStorage): boolean {
  try {
    return storage.getItem(TOUR_SEEN_STORAGE_KEY) !== "1";
  } catch {
    return false;
  }
}

export function markTourSeen(storage: TourFlagStorage): void {
  try {
    storage.setItem(TOUR_SEEN_STORAGE_KEY, "1");
  } catch {
    // Storage unavailable (private mode quota); tour simply shows again next launch.
  }
}

export function resetTourSeen(storage: TourFlagStorage): void {
  try {
    storage.removeItem(TOUR_SEEN_STORAGE_KEY);
  } catch {
    // See markTourSeen.
  }
}

export function requestAppTourReplay(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(TOUR_REPLAY_EVENT));
}
